import { createAxios } from "./axiosHttpMarconi";

export const seguroConfigService = { get, update };

function get() {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/seguro-config`;
  return axios.get(urlPath);
}

function update(body) {
  const axios = createAxios();
  let franquiciadora = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${franquiciadora.extraData.franquiciadoraId}/seguro-config`;
  return axios.put(urlPath, body);
}
